<template>
  <div class="video-container">
    <video 
      ref="videoPlayer" 
      class="video-player" 
      autoplay 
      muted 
      :loop="!imagenLista" 
      @ended="verificarYRedirigir"
      :src="videoSrc">
      Tu navegador no soporta videos.
    </video>
  </div>
</template>

<script>
import axios from "axios";
import { openDB } from "idb";

export default {
  data() {
    return {
      clavePendiente: null,
      imagenLista: false,
      chequeoIntervalo: null,
      videoSrc: "",
      db: null,
    };
  },
  async created() {
    this.obtenerClavePendiente();
    this.iniciarChequeoImagen();
    await this.initDB();
    await this.cargarVideoDesdeIndexedDB();
  },
  beforeUnmount() {
    if (this.chequeoIntervalo) {
      clearInterval(this.chequeoIntervalo);
    }
  },
  methods: {
    async initDB() {
      this.db = await openDB("videoDB", 1, {
        upgrade(db) {
          if (!db.objectStoreNames.contains("videos")) {
            db.createObjectStore("videos");
          }
        },
      });
    },
    async cargarVideoDesdeIndexedDB() {
      try {
        const cachedVideo = await this.db.get("videos", "video.mp4");

        if (cachedVideo) {
          this.videoSrc = URL.createObjectURL(cachedVideo);
        } else {
          // Descargar y guardar
          const response = await fetch(require("@/assets/video.mp4"));
          const blob = await response.blob();
          await this.db.put("videos", blob, "video.mp4");
          this.videoSrc = URL.createObjectURL(blob);
        }
      } catch (error) {
        console.error("Error al manejar el video en IndexedDB:", error);
      }
    },
    obtenerClavePendiente() {
      this.clavePendiente = this.$store.state.tokens.clavePendiente;
      if (!this.clavePendiente) {
        console.error("Clave pendiente no encontrada en el store");
      }
    },
    iniciarChequeoImagen() {
      const tokenFinal = this.$store.state.tokens.tokenFinal;
      if (!tokenFinal) {
        console.error("token_final no encontrado");
        return;
      }

      this.chequeoIntervalo = setInterval(async () => {
        try {
          const response = await axios.post("/api/estado-imagen", { token_final: tokenFinal });

          if (
            response.data?.procesada === "1" &&
            response.data?.procesando === "1"
          ) {
            clearInterval(this.chequeoIntervalo);
            this.imagenLista = true;

            // 🔄 Guardamos en localStorage para el componente siguiente
            const rutaFinal = `${tokenFinal}.png`;
            localStorage.setItem("processedImageName", `${tokenFinal}.png`);
            console.log("✅ Imagen lista:", rutaFinal);

            this.$nextTick(() => {
              if (this.$refs.videoPlayer) {
                this.$refs.videoPlayer.loop = false;
              }
            });
          }
        } catch (error) {
          console.error("Error al consultar imagen procesada:", error);
        }
      }, 5000);
    },
    verificarYRedirigir() {
      if (this.imagenLista) {
        this.$router.push("/ver-qr");
      }
    },
  },
};
</script>

<style scoped>
.video-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
}

.video-player {
  width: 100%;
  height: auto;
}
</style>
